// Настройки куки сессии Supabase для cortivox.
//
// В отличие от ezspeech/intellect (которые делят одну SSO-куку на .ezspeech.ai),
// cortivox живёт на отдельном домене и имеет СОБСТВЕННУЮ авторизацию. Поэтому:
//   1. Имя куки — своё (`sb-cortivox-auth-token`), чтобы сессии никогда не
//      пересекались с соседними приложениями, даже если однажды окажутся на
//      родственных хостах.
//   2. Домен НЕ задаётся константой на окружение, а выводится из хоста, на
//      котором приложение реально открыто (см. resolveCookieDomain). Для apex
//      cortivox.ai и для localhost это host-only кука — ровно то, что нужно
//      независимой авторизации.

export const AUTH_COOKIE_NAME = 'sb-cortivox-auth-token';

/**
 * Родительский домен для куки по хосту. undefined => host-only кука.
 *
 *   app.cortivox.ai       -> .cortivox.ai   (делится с соседними поддоменами)
 *   cortivox.ai (apex)    -> undefined      (нет родителя; '.ai' — публичный суффикс)
 *   localhost / 127.0.0.1 -> undefined      (делиться не с кем)
 */
export function resolveCookieDomain(hostname) {
  if (!hostname) return undefined;

  // IPv4-литерал или IPv6 в скобках — домен у куки невозможен.
  if (/^\[|^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return undefined;

  const labels = hostname.split('.').filter(Boolean);

  // 'localhost' (1 метка) и apex вида 'cortivox.ai' (2 метки) не имеют
  // разделяемого родителя — только поддомен имеет.
  if (labels.length < 3) return undefined;

  return '.' + labels.slice(1).join('.');
}

/**
 * cookieOptions для @supabase/ssr createBrowserClient.
 * secure следует за реальной схемой, а не за флагом dev/prod: Secure-кука по
 * обычному http молча отбрасывается — именно так это и ломается.
 */
export function authCookieOptions(location) {
  return {
    name: AUTH_COOKIE_NAME,
    domain:
      process.env.REACT_APP_AUTH_COOKIE_DOMAIN ||
      resolveCookieDomain(location.hostname),
    path: '/',
    sameSite: 'lax',
    secure: location.protocol === 'https:',
  };
}
